import { useEffect, useState } from "react";
import { useData } from "@/context/DataContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

/** Shared editing harness for every HQ vault editor. */
export function useDraft(key) {
  const { content, saveContent } = useData();
  const [draft, setDraft] = useState(content[key]);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    setDraft(content[key]);
    setDirty(false);
  }, [content, key]);

  const update = (next) => {
    setDraft(next);
    setDirty(true);
  };

  const save = async () => {
    await saveContent(key, draft);
    setDirty(false);
    toast.success(`${key} saved to Smash HQ`);
  };

  return { draft, update, save, dirty };
}

export const SaveBar = ({ dirty, save, onAdd, addLabel, testId }) => (
  <div className="sticky top-0 z-10 -mx-1 mb-5 flex items-center gap-3 border-b border-border bg-background/95 px-1 py-3 backdrop-blur">
    {onAdd && (
      <Button
        data-testid={`${testId}-add`}
        variant="outline"
        onClick={onAdd}
        className="rounded-sm border-border display text-lg uppercase hover:border-primary hover:text-primary"
      >
        {addLabel}
      </Button>
    )}
    <Button
      data-testid={`${testId}-save`}
      onClick={save}
      className="ml-auto rounded-sm bg-primary text-primary-foreground display text-lg uppercase hover:bg-[#E6C800]"
    >
      {dirty ? "Save changes" : "Saved"}
    </Button>
  </div>
);

export const Field = ({ label, children }) => (
  <div>
    <div className="mono text-[10px] tracking-widest text-muted-foreground">{label}</div>
    <div className="mt-1">{children}</div>
  </div>
);
